(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .factory('SubcategorySearch', SubcategorySearch);

    SubcategorySearch.$inject = ['$resource'];

    function SubcategorySearch($resource) {
        var resourceUrl =  'api/_search/subcategories/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
